export default __webpack_public_path__ + "static/media/dispositivos-conclusao.51817c3e.png";